import { cloneElement } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { TYPE_TO_ICON } from '@/components/buttons/ActionButton/constants';
import { actionButtonStyled } from '@/styles/overrides';
import { BoxStyled } from './styled';
import { DropdpownMenuProps } from './types';
import useController from './useController';

const DropdpownMenu = ({ items, label }: DropdpownMenuProps) => {
  const { anchorEl, buttonRef, clearCloseTimer, handleClose, handleOpen, open, rootRef, scheduleClose, setAnchorEl } =
    useController();

  return (
    <BoxStyled
      ref={rootRef}
      onMouseEnter={() => {
        clearCloseTimer();
        const el = buttonRef.current;
        if (el) setAnchorEl(el);
      }}
      onMouseLeave={scheduleClose}
    >
      <Button
        ref={buttonRef}
        aria-expanded={open}
        aria-haspopup="true"
        aria-label={`${label} menu`}
        color="primary"
        endIcon={<ExpandMoreIcon sx={{ height: 18, width: 18 }} />}
        onClick={handleOpen}
        sx={(theme) => actionButtonStyled(theme)}
      >
        {label}
      </Button>
      {open ? (
        <Menu
          anchorEl={anchorEl}
          container={() => rootRef.current ?? document.body}
          onClose={handleClose}
          open
          slotProps={{
            root: {
              sx: { zIndex: (theme) => theme.zIndex.modal },
            },
          }}
        >
          {items?.map(({ disabled, iconType, label, linkProps, onClick, shouldRender = true }) =>
            shouldRender ? (
              <MenuItem
                disabled={disabled}
                onClick={() => {
                  if (disabled) return;
                  onClick?.();
                  handleClose();
                }}
                {...(linkProps && { component: 'a', rel: 'noreferrer noopener', target: '_blank', ...linkProps })}
              >
                <ListItemIcon>{cloneElement(TYPE_TO_ICON[iconType], { fontSize: 'small' })}</ListItemIcon>
                {label}
              </MenuItem>
            ) : null
          )}
        </Menu>
      ) : null}
    </BoxStyled>
  );
};

export default DropdpownMenu;
